import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiCommonService } from './services/ui-common.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [UiCommonService],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error(
                `Core Module has already been loaded. Import Core modules in the AppModule only`
            );
        }
    }
}
